/**
 * Homepage — katalog tab kategori + horizontal product track
 */
import Alpine from 'alpinejs';

Alpine.data('catalogTabs', () => ({
  active: 0,
  dir: 1,

  select(index) {
    if (index === this.active) return;
    this.dir = index > this.active ? 1 : -1;
    this.active = index;
    this.$nextTick(() => this.resetTrackScroll());
  },

  resetTrackScroll() {
    const root = this.$root;
    const panel = root.querySelector('.mkt-catalog-tabs__panel.is-active');
    const track = panel?.querySelector('.mkt-catalog-tabs__track');
    if (track) track.scrollLeft = 0;
  },

  scrollTrack(event, direction) {
    const track = event.currentTarget
      ?.closest('.mkt-catalog-tabs__panel-wrap')
      ?.querySelector('.mkt-catalog-tabs__track');
    if (!track) return;
    track.scrollBy({ left: direction * 300, behavior: 'smooth' });
  },
}));
